import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./status.module.scss";

export function ActiveStatus() {
  const { t } = useTranslation();

  return (
    <Pill
      styleName={"accepted"}
      Lefticon={<img src={"../../../assets/images/svg/active.svg"} />}>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_contract_details_transaction_active")}
      </p>
    </Pill>
  );
}
